package com.karawek.core.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.tooling.preview.PreviewParameter
import androidx.compose.ui.unit.dp
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography
import com.karawek.core.ui.theme.ThemeMode
import com.karawek.core.ui.theme.ThemeModeProvider
import com.karawek.core.ui.theme.CoreLightColorScheme
import com.karawek.core.ui.theme.CoreDarkColorScheme

@Composable
fun CoreHeader(
    title: String? = null,
    showBack: Boolean = false,
    onBack: (() -> Unit)? = null,
    actionText: String? = null,
    onAction: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    val headerHeight = 56.dp

    Box(
        modifier = modifier
            .fillMaxWidth()
            .height(headerHeight)
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier
                .fillMaxSize()
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.weight(1f, fill = false)
            ) {
                if (showBack && onBack != null) {
                    IconButton(
                        onClick = onBack,
                        modifier = Modifier.padding()
                    ) {
                        Icon(
                            imageVector = Icons.AutoMirrored.Filled.ArrowBack,
                            contentDescription = "Back",
                            tint = CoreTheme.colors.onBackground,
                        )
                    }
                }
                else {
                    Spacer(modifier = Modifier.width(CoreSpacing.md))
                }

                title?.let {
                    Text(
                        text = it,
                        color = CoreTheme.colors.onBackground,
                        style = CoreTypography.headline,
                        modifier = Modifier,
                    )
                }
            }

            if (actionText != null && onAction != null) {
                Text(
                    text = actionText,
                    style = CoreTypography.bodySecondary,
                    color = CoreTheme.colors.textSecondary,
                    modifier = Modifier
                        .clickable { onAction() }
                        .padding(end = CoreSpacing.md),
                )
            }
        }
    }
}

@Preview
@Composable
private fun CoreHeaderPreview(
    @PreviewParameter(ThemeModeProvider::class) themeMode: ThemeMode,
) {
    CoreTheme(lightColors = CoreLightColorScheme, darkColors = CoreDarkColorScheme, themeMode = themeMode) {
        CoreHeader(
            title = "Header Title",
            showBack = true,
            modifier = Modifier.background(CoreTheme.colors.background)
        )
    }
}

@Preview
@Composable
private fun CoreHeaderWithBackButtonPreview(
    @PreviewParameter(ThemeModeProvider::class) themeMode: ThemeMode,
) {
    CoreTheme(lightColors = CoreLightColorScheme, darkColors = CoreDarkColorScheme, themeMode = themeMode) {
        CoreHeader(
            title = "Header Title",
            showBack = true,
            onBack = {},
            modifier = Modifier.background(CoreTheme.colors.background)
        )
    }
}

@Preview
@Composable
private fun CoreHeaderWithActionPreview(
    @PreviewParameter(ThemeModeProvider::class) themeMode: ThemeMode,
) {
    CoreTheme(lightColors = CoreLightColorScheme, darkColors = CoreDarkColorScheme, themeMode = themeMode) {
        CoreHeader(
            title = "Header Title",
            actionText = "Skip",
            onAction = {},
            modifier = Modifier.background(CoreTheme.colors.background)
        )
    }
}
